import { FETCH_BADGES_SUCCESS } from '../actions/fetch-badges';

export function badges(state = [], action) {
  switch (action.type) {
    case FETCH_BADGES_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}
